// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/sigmet-airmet-phenomenon-line.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/sigmet-airmet-phenomenon-line/sigmet-airmet-phenomenon-line.js';

mount([g0]);
